const C = {
  name: "Weight",
  dimensions: { width: 24, height: 24 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4649 8C15.8052 7.41165 16 6.72857 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 6.72857 8.19479 7.41165 8.53513 8H7.00001C6.51117 8 6.09398 8.35341 6.01361 8.8356L4.01361 20.8356C3.96529 21.1256 4.04698 21.4221 4.23699 21.6464C4.42699 21.8707 4.70606 22 5.00001 22H19C19.294 22 19.573 21.8707 19.763 21.6464C19.953 21.4221 20.0347 21.1256 19.9864 20.8356L17.9864 8.8356C17.906 8.35341 17.4888 8 17 8H15.4649ZM10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6ZM7.84713 10L6.18047 20H17.8195L16.1529 10H7.84713Z" fill="currentColor"/>
   `
};
export {
  C as Weight
};
